import React from 'react';

import { useTriviaQuestions } from '../hooks/useTriviaQuestions';

import { QuestionsDesktop, QuestionsMobile } from './Questions';

import { Loader, Modal } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { ResponseDashTriviaInit } from '@/types/dashboard';

export interface TriviaQuestionsProps {
  triviaData?: ResponseDashTriviaInit;
}

export const TriviaQuestions = React.memo((data: TriviaQuestionsProps) => {
  const { isMobile } = useIsDesktop();
  const hookQuestion = useTriviaQuestions(data);

  return (
    <>
      <Loader isVisible={hookQuestion.isLoading} />

      {/* TRIVIA QUESTIONS COMPONENT */}
      {isMobile ? (
        <QuestionsMobile {...hookQuestion} />
      ) : (
        <QuestionsDesktop {...hookQuestion} />
      )}

      <Modal
        controlledOnClose={hookQuestion.closeModal}
        isControlledOpen={hookQuestion.showTimeoutModal}
        render={() =>
          'Finalizó el tiempo para responder. Conocé los resultados de esta trivia'
        }
        size="2xs"
        title="Importante"
        variant="controlled"
      />
    </>
  );
});

TriviaQuestions.displayName = 'TriviaQuestions';
